import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function DbtIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Box as="g" clipPath="url(#dbt-a)">
        <Box
          as="path"
          fill="#FF694A"
          d="M19.15.832a2.79 2.79 0 0 1 .85 1.7c0 .27-.072.452-.235.795-.163.344-2.17 3.816-2.767 4.774a3.643 3.643 0 0 0 0 3.762c.597.958 2.604 4.448 2.767 4.792.163.343.235.506.235.777a2.676 2.676 0 0 1-.832 1.682c-.452.47-1.049.777-1.682.832-.27 0-.452-.073-.777-.235-.326-.163-3.87-2.116-4.828-2.713-.073-.036-.145-.09-.235-.126l-4.738-2.803c.108.904.506 1.772 1.157 2.405.127.126.253.235.398.343-.109.055-.235.109-.344.181-.958.597-4.448 2.604-4.792 2.767-.343.163-.506.235-.795.235a2.676 2.676 0 0 1-1.682-.832 2.79 2.79 0 0 1-.85-1.7c.018-.27.09-.542.235-.777.163-.344 2.17-3.834 2.767-4.792a3.6 3.6 0 0 0 .524-1.88c0-.67-.18-1.321-.524-1.882C2.405 7.143.38 3.653.235 3.31A1.696 1.696 0 0 1 0 2.532a2.767 2.767 0 0 1 .832-1.7A2.767 2.767 0 0 1 2.532 0c.27.018.542.09.795.235.29.127 2.84 1.61 4.196 2.405l.307.181c.109.072.199.127.271.163l.145.09 4.828 2.857a3.98 3.98 0 0 0-1.537-2.748c.109-.055.235-.109.344-.181.958-.597 4.448-2.622 4.792-2.767.235-.145.506-.217.795-.235.633.072 1.23.362 1.682.832Zm-8.897 10.452 1.03-1.03a.35.35 0 0 0 0-.507l-1.03-1.03a.35.35 0 0 0-.506 0l-1.03 1.03a.35.35 0 0 0 0 .506l1.03 1.03c.126.128.361.128.506 0Z"
        />
      </Box>
      <Box as="defs">
        <Box as="clipPath" id="dbt-a">
          <Box as="path" fill="#fff" d="M0 0h20v20H0z" />
        </Box>
      </Box>
    </Icon>
  );
}
